<template>
  <div>
    <div class="textBox d-flex">
        <v-card v-if="gallery"  tile  color="transparent" height='50%' :class="screenType" width="100vw">
        <v-col :cols="widthCol">
        <v-card-text class="pt-0 text-p">{{counter + 1}}/{{input[1] + 1}}</v-card-text>
          <v-card-title :class="textStyle[0]">{{input[0][counter].title}}</v-card-title>
          <v-card-text :class="textStyle[1]">{{input[0][counter].text}}<p v-if="counter == input[1]" style="display:inline;">  &#128522;</p></v-card-text>
          <v-card-subtitle v-if="counter == input[1]" :class="textStyle[1]"><strong>Number: </strong>{{input[0][counter].number}}</v-card-subtitle>
          <v-card-subtitle v-if="counter == input[1]" :class="textStyle[1]"><strong>Email: </strong>{{input[0][counter].email}}</v-card-subtitle>
          <v-card-subtitle v-if="counter == input[1]" :class="textStyle[1]"><strong>Instagram: </strong>{{input[0][counter].insta}}</v-card-subtitle>
          <v-card-subtitle v-if='counter != 0 && counter != input[1]' :class="textStyle[1]"><strong>Designer: </strong>{{input[0][counter].designer}}</v-card-subtitle>
          <v-card-subtitle v-if='counter != 0 && counter != input[1] && input[0][counter].link != "none"' :class="textStyle[1]"><a :href="input[0][counter].link" target="_blank">Link to project</a></v-card-subtitle>
        </v-col>
        </v-card>
    </div>
      <v-col class="float-right pa-0" md="7">
        <div class="buffer d-flex">
        <v-card v-if="!gallery"  tile  color="transparent" :class="screenType" width="auto">
        <v-col :cols="widthCol">
        <v-card-text class="pt-0 text-p">{{counter + 1}}/{{input[1] + 1}}</v-card-text>
          <v-card-title :class="textStyle[0]">{{input[0][0].title}}</v-card-title>
          <v-card-text :class="textStyle[1]">{{input[0][0].text}}</v-card-text>
        </v-col>
        </v-card>
          <v-col class="d-flex pa-12" v-if="gallery">
              <v-card width="85%" tile class="d-flex flex-wrap align-self-center elevation-0 pa-0 ma-0">
            <v-hover v-slot:default="{ hover }" v-for="index in 6" :key="index">
            <v-card tile @click='jumpTo(index)' class="preview elevation-0 ma-0 pa-1" width="50%">
          <v-img eager :aspect-ratio="16/9" :src="require(`@/assets/${input[0][index].image}`)"
          >
                    <v-expand-transition>
                        <v-card v-if="hover" tile class="transition-fast-in-fast-out grey darken-2 v-card--reveal text-p" style="height: 100%;">
                          <v-card-text :class="textStyle[2]"><strong>{{input[0][index].title}}</strong></v-card-text>
                          <v-card-text :class="textStyle[3]">{{input[0][index].designer}}</v-card-text>
                        </v-card>
                    </v-expand-transition>
                </v-img>
            </v-card>
        </v-hover>
            </v-card>
          </v-col>
        </div>
        <div class="box d-flex" v-for="index in (input[1]-1)" :ref="index" :key="index">
        <v-card tile  color="transparent" :class="imageWidth[0]" :width="imageWidth[2]">
          <div v-if="!gallery" class="imageBuffer" ></div>
              <v-img eager
              :aspect-ratio="16/9"
              class="pa-0 ma-0"
      :src="require(`@/assets/${input[0][index].image}`)"
      height="auto"
    ></v-img>
          <v-card-text v-if="!gallery" class="pb-2 pt-5 text-p">{{index}}/{{input[1]}}</v-card-text>
          <v-card-title v-if="!gallery" :class="textStyle[0]">{{input[0][index].title}}</v-card-title>
          <v-card-text v-if="!gallery"  :class="textStyle[1]">{{input[0][index].text}}</v-card-text>
          <v-card-text v-if="!gallery" v-show='counter != 0 ' :class="textStyle[1]"><strong>Designer:</strong>{{input[0][index].designer}}</v-card-text>
          <v-card-text v-if="!gallery && input[0][counter].link != 'none'"  v-show='counter != 0 ' :class="textStyle[1]"><a :href="input[0][index].link" target="_blank">Link to project</a></v-card-text>
        </v-card>
        </div>
        <div class="buffer d-flex">
        <v-card v-if="!gallery"  tile  color="transparent" height='50%' :class="screenType" width="auto">
        <v-col :cols="widthCol">
        <v-card-text class="pt-0 text-p">{{input[1]}}/{{input[1]}}</v-card-text>
          <v-card-title :class="textStyle[0]">{{input[0][input[1]].title}}</v-card-title>
          <v-card-text :class="textStyle[1]">{{input[0][input[1]].text}} <p style="display:inline;"> &#128522;</p></v-card-text>
          <v-card-subtitle :class="textStyle[1]"><strong>Number: </strong>{{input[0][input[1]].number}}</v-card-subtitle>
          <v-card-subtitle  :class="textStyle[1]"><strong>Email: </strong>{{input[0][input[1]].email}}</v-card-subtitle>
          <v-card-subtitle  :class="textStyle[1]"><strong>Instagram: </strong>{{input[0][input[1]].insta}}</v-card-subtitle>
        </v-col>
        </v-card>
        </div>
      </v-col>
  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'
import pageData from '@/data/data.js'
import * as easings from 'vuetify/lib/services/goto/easing-patterns'

export default {
  name: 'Home',
  props:['inputData'],
  data(){
    return {
      visible: false,
      scrollPos: 0,
      windowHeight: window.innerHeight,
      windowTop:0,
      lastScrollTop:0,
      preventScroll:false,
      counter:0,
      count:0,
      tranistion:true,
      duration: 200,
      offset: 0,
      easing: 'easeOutQuad',
      easings: Object.keys(easings),
    };
  },
    mounted() {
    window.addEventListener('scroll', this.debounceMethod);
    window.addEventListener('wheel', this.debounceMethod);
    window.addEventListener('scroll', this.throttleScroll);
    window.addEventListener('wheel', this.throttleScroll);
    window.addEventListener('scroll', this.throttleChange);
    window.addEventListener('wheel', this.throttleChange);
  },
  computed:{
       breakpoint(){
     if(this.$vuetify.breakpoint.mdAndUp == true){
       return true
     }else{
       return false
     }
   },
    options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },
      jumpOptions () {
        return {
          duration: 600,
          offset: this.offset,
          easing: this.easing,
        }
      },
    input(){
      let data = pageData[this.inputData]
      let length = (Object.keys(data).length - 1)
      return [data,length]
    },
    screenType () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            return 'align-self-top elevation-0 mt-16 pt-8'
          case 'sm': 
            return 'align-self-top elevation-0 mt-16 pt-16'
          case 'md': 
            return 'align-self-center elevation-0 ml-16'
          case 'lg': 
            return 'align-self-center elevation-0 ml-16'
          case 'xl': 
            return 'align-self-center elevation-0 ml-16'
        }
        return 6
      },
      gallery () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            return false
          case 'sm': 
            return false
          case 'md': 
            return true
          case 'lg': 
            return true
          case 'xl': 
            return true
        }
        return false
      },
      imageWidth () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            return ['elevation-0 align-self-top', '40vh', 'auto']
          case 'sm': 
            return ['elevation-0 align-self-top', '50vh', 'auto']
          case 'md': 
            return ['elevation-0 align-self-center','auto' , '90%']
          case 'lg': 
            return ['elevation-0 align-self-center','auto' , '90%']
          case 'xl': 
            return ['elevation-0 align-self-center','auto' , '90%']
        }
        return false
      },
      widthCol () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            return 12
          case 'sm': 
            return 6
          case 'md': 
            return 4
          case 'lg': 
            return 4
          case 'xl': 
            return 4
        }
        return 6
      },
      textStyle () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            return ['pt-2','pt-0 text-p black--text','pt-5 white--text']
          case 'sm': 
            return ['pt-2 font-weight-bold text-h5','pt-0 text-p','pt-5 text-h6 white--text','pt-2 font-weight-bold text-p white--text']
          case 'md': 
            return ['pt-2 font-weight-bold text-h5','pt-0 text-p black--text', 'pt-5 text-h6 white--text','font-weight-bold pt-2 text-p white--text']
          case 'lg': 
            return ['pt-2 font-weight-bold text-h5','pt-0 text-p', 'pt-5 text-h6 white--text','font-weight-bold pt-2 text-p white--text']
          case 'xl': 
            return ['pt-2 font-weight-bold text-h4','pt-0 text-h6', 'pt-5 text-h6 white--text', 'font-weight-bold pt-2 text-p white--text']
        }
        return 6
      },
  },
  methods:{
    jumpTo(key){
      let object = this.$refs[key]
      this.$vuetify.goTo(object[0], this.jumpOptions)
      
    },
    debounceMethod: _.debounce(function() {
      if(this.gallery != false){
      let wh = document.documentElement.scrollHeight
      var docHeight = window.innerHeight
      this.windowTop = window.top.scrollY
      let scrollSection = Math.floor((wh - docHeight)/this.input[1])
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if(st > docHeight){
      let direction = (((st - docHeight)/scrollSection*1)+1)
      let scroll = Math.floor(((st - docHeight)/scrollSection*1)+1.5)
      let position = direction - scroll
      if(position >= 0.1 || position <= 0.45 || position <= 0.99 || position >= 0.55 && scroll != this.scrollPos){
        this.debounceJump(scroll,direction)
      }
      }
      else if(st <= docHeight && this.scrollPos != 0){
        //this.tranistion = false
        setTimeout(()=>{
        this.scrollPos = 0 
        this.tranistion= true
        },10)
      }
      if(this.count != 1){
      this.count = 1
      if(this.counter != 0 || this.counter != 11){
        setTimeout(()=>{
        this.tranistion = true
        this.count = 0
      },700)
      }else{
        this.tranistion = true
      }
      }
      }
    }, 250),
    debounceJump: _.throttle(function(scroll,direction){
        let weight = direction - scroll
        let side = 0
        if(weight <= 0.5){
          side = 0
        }else{
          side = 1
        }
        if(scroll >= 0 && scroll != this.input[1]){
        let object = this.$refs[scroll + side]
        this.$vuetify.goTo(object[0], this.options)
        }
        this.scrollPos = scroll + side
    },10,{trailing:false}),
  throttleScroll: _.throttle(function(){
    let wh = document.documentElement.scrollHeight
    var docHeight = window.innerHeight
    let scrollSection = Math.floor((wh - docHeight)/this.input[1])
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    let scroll = Math.floor(((st - docHeight)/scrollSection)+1.5)
    this.counter = scroll
  },50,{trailing:true}),
  },
      beforeDestroy() {
    window.removeEventListener('scroll', this.debounceMethod);
    window.removeEventListener('wheel', this.debounceMethod);
    },
}
</script>
<style scoped>
.preview{
  cursor:pointer;
}
.homePage{
  position:relative;
  overflow:hidden;
}
.buffer{
  height:100vh
}
.buffers{
  height:100vh
}
.imageBuffer{
  height:10%;
}
.link{
  cursor: pointer;
  text-decoration: underline;
}
.space{
    height:0.5em;
    margin-top:1em;
    margin-bottom:1em;
    width:80%;
}
.box{
  height:100vh;
  z-index:0;
  position:relative;
}
.fade-leave-active {
  transition: opacity .05s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity .05s;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.textCount{
  position:absolute;
  left:1.5em;
  top:1em;
}
.textBox{
  height:100vh;
  position:fixed;
}
a{
  color:black;
}
.v-card--reveal {
   background-image: url(data:image/png;base64,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);
    background-color: #1F1F1F !important;  
    background-repeat: repeat;
    backdrop-filter: blur(50px) !important;
    align-items: center;
    top: 0;
    justify-content: center;
    opacity: .9;
    position: absolute;
    width: 100%;
}

</style>
